import React from 'react';

import { useLocation, useNavigate, useParams } from 'react-router-dom';

import ErrorPage from '@/components/errors/ErrorPage';
import SingleColumnTemplate from '@/components/layouts/SingleColumnTemplate';
import Jumbotron from '@/components/ui/box/Jumbotron';
import JumbotronButtonArea from '@/components/ui/box/JumbotronButtonArea.tsx';
import JumbotronDescription from '@/components/ui/box/JumbotronDescription.tsx';
import JumbotronPanel from '@/components/ui/box/JumbotronPanel';
import JumbotronTitle from '@/components/ui/box/JumbotronTitle.tsx';
import Button from '@/components/ui/buttons/Button';
import { pageTitles } from '@/constants/pageTitles';

import styles from './InviteEmailErrorPage.module.scss';

type LocationState = {
  email: string;
};

const InviteEmailErrorPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { code } = useParams<{ code: string }>();

  const state = location.state as LocationState | null;

  if (!code) {
    return <ErrorPage type="not_found" />;
  }

  const handleBack = () => {
    navigate(`/mypage/invite/${code}`, {
      state: { email: state?.email },
    });
  };

  return (
    <SingleColumnTemplate>
      <div className={styles.InviteEmailErrorPage}>
        <Jumbotron>
          <JumbotronPanel panelHeaderTitle={pageTitles.inviteEmailConfirm}>
            <JumbotronTitle>メールアドレスが無効です</JumbotronTitle>
            <JumbotronDescription>
              <span className={styles.line}>
                指定したメールアドレスは既に生徒に紐付いています。
              </span>
              別のメールアドレスを入力してください。
            </JumbotronDescription>
            <JumbotronButtonArea>
              <Button
                type="button"
                color="primary"
                size="m"
                onClick={handleBack}
              >
                メールアドレス入力画面へ
              </Button>
            </JumbotronButtonArea>
          </JumbotronPanel>
        </Jumbotron>
      </div>
    </SingleColumnTemplate>
  );
};

export default InviteEmailErrorPage;
